import React from "react";

import IconButton from "../../../../../packages/IconButton";
import { CloseCircleIcon } from "../../../../../packages/SVGs";
import WPHeading from "../../../../../packages/WPHeading";
import { WPInputHelperText } from "../../../../../packages/WPInputHelperText/WPInputHelperText";

import { USERS_TABLE_HEADER_CONFIG } from "../SelectedUserHeader/UsersTableHeader.constants";

import { combineClassNames } from "../../../../../utils/appUtils";

import "./SelectedUserRenderer.scss";

const SelectedUserRenderer = ({ item, index, onRemove }) => {
  const cellContentMap = {
    text: () => (
      <WPHeading
        id={`user-name-${index}`}
        size="small"
        secondary
        type="default"
        tooltip={item?.userData?.[0]?.name}
      >
        {item?.userData?.[0]?.name || "-"}
      </WPHeading>
    ),
    mail: () => (
      <>
        <WPHeading
          id={`user-email-${index}`}
          size="small"
          type="default"
          secondary
          fontNoto
          tooltip={item?.email}
        >
          {item?.email}
        </WPHeading>
        <WPInputHelperText
          id={`email-error-${index}`}
          isError={Boolean(item?.error)}
          isWarning={Boolean(item?.warning)}
          text={item?.error || item?.warning}
          hide={!item?.error && !item?.warning}
          position="static"
        />
      </>
    ),
    remove: () => (
      <IconButton
        className="remove-button"
        id={`remove-btn-${index}`}
        name={`remove-btn-${index}`}
        onClick={onRemove}
      >
        <CloseCircleIcon />
      </IconButton>
    ),
  };

  return (
    <div className="selected-users">
      <div className="selected-users-row">
        {USERS_TABLE_HEADER_CONFIG.map(
          ({ id, field, type, minWidth, flex }) => (
            <div
              key={id}
              className={combineClassNames(
                "selected-users-field",
                `${field}-column`,
                `${type}-column`,
              )}
              style={{
                minWidth:
                  typeof minWidth === "number" ? `${minWidth}px` : minWidth,
                flex: flex || undefined,
              }}
            >
              {(cellContentMap[type] || cellContentMap.text)()}
            </div>
          ),
        )}
      </div>
    </div>
  );
};

export default SelectedUserRenderer;
